import React, { Fragment } from 'react';
import * as Cookies from 'js-cookie';
import '../assets/meeting.css';
import { merge } from 'lodash';
import AgoraRTC from 'agora-rtc-sdk';
import { Link } from 'react-router-dom';
import '../assets/canvas.css';
import '../assets/fonts/css/icons.css';
import auth from '../../../helpers/auth';
import { socket } from '../../../helpers/socketHelper';
import Countdown from 'react-countdown';
import config from '../../../config';
import $ from 'jquery';
import firebase from '../../../helpers/firebase.config';

const tile_canvas = {
  1: ['span 12/span 24'],
  2: ['span 12/span 12/13/25', 'span 12/span 12/13/13'],
  3: ['span 6/span 12', 'span 6/span 12', 'span 6/span 12/7/19'],
  4: [
    'span 6/span 12',
    'span 6/span 12',
    'span 6/span 12',
    'span 6/span 12/7/13',
  ],
  5: [
    'span 3/span 4/13/9',
    'span 3/span 4/13/13',
    'span 3/span 4/13/17',
    'span 3/span 4/13/21',
    'span 9/span 16/10/21',
  ],
  6: [
    'span 3/span 4/13/7',
    'span 3/span 4/13/11',
    'span 3/span 4/13/15',
    'span 3/span 4/13/19',
    'span 3/span 4/13/23',
    'span 9/span 16/10/21',
  ],
  7: [
    'span 3/span 4/13/5',
    'span 3/span 4/13/9',
    'span 3/span 4/13/13',
    'span 3/span 4/13/17',
    'span 3/span 4/13/21',
    'span 3/span 4/13/25',
    'span 9/span 16/10/21',
  ],
};

class Meeting extends React.Component {
  constructor(props) {
    super(props);
    this.client = {};
    this.localStream = {};
    this.shareClient = {};
    this.shareStream = {};
    this.state = {
      displayMode: 'pip',
      streamList: [],
      readyState: false,
      showTimer: false,
      DateNow: new Date(),
    };
    this.videoProfile = '720p_5';
    this.transcode = 'interop'; //Cookies.get('transcode') || 'interop';
    this.attendeeMode = 'video'; //Cookies.get('attendeeMode') || 'video';
    this.baseMode = 'avc'; //Cookies.get('baseMode') || 'avc';
    this.appId = process.env.REACT_APP_AGORA_API_KEY;
    this.uid = undefined;
  }

  calcTimeDelta(props) {
    console.log(props);
  }

  onTimeOver(props) {
    if (auth.getUserType() === 'User') {
      this.props.history.push('/dashboard/appointments');
    } else {
      this.props.history.push('/coach/dashboard');
    }
  }

  async componentWillMount() {
    let { channel_id } = await this.props.selectState;
    // alert(channel_id);
    // if (auth.getUserType() === 'User') {
    //   if (!channel_id) {
    //     const channelId = localStorage.getItem('email');
    //     channel_id = channelId;
    //   }
    // } else {
    //   if (!channel_id) {
    //     const channelId = localStorage.getItem('C_ChannelId');
    //     channel_id = channelId;
    //   }
    // }
    let $ = this;
    // init AgoraRTC local client
    this.client = AgoraRTC.createClient({ mode: $.transcode });
    this.client.init($.appId, () => {
      console.log(channel_id + 'AgoraRTC client initialized');
      this.subscribeStreamEvents();
      this.client.join($.appId, channel_id, $.uid, (uid) => {
        console.log('User ' + uid + ' join channel successfully');
        console.log('At ' + new Date().toLocaleTimeString());
        localStorage.setItem('call_pick_time', new Date());
        this.localStream = this.streamInit(uid, $.attendeeMode, $.videoProfile);
        this.localStream.init(
          () => {
            if ($.attendeeMode !== 'audience') {
              this.addStream(this.localStream, true);
              this.client.publish(this.localStream, (err) => {
                console.log('Publish local stream error: ' + err);
              });
            }
            this.setState({ readyState: true });
          },
          (err) => {
            console.log('getUserMedia failed', err);
            this.setState({ readyState: true });
          }
        );
      });
    });
    // let call_duration = this.props.selectState.call_duration;
    // let videoSessionSlot = this.props.selectState.videoSessionSlot;
  }

  async componentDidMount() {
    window.onbeforeunload = function () {
      return 'Are you sure you want to leave?';
    };
    let body = document.body;
    body.className = 'agora_session';

    var docElm = document.body;
    if (docElm.requestFullscreen) {
      docElm.requestFullscreen();
    } else if (docElm.msRequestFullscreen) {
      docElm.msRequestFullscreen();
    } else if (docElm.mozRequestFullScreen) {
      docElm.mozRequestFullScreen();
    } else if (docElm.webkitRequestFullScreen) {
      docElm.webkitRequestFullScreen();
    }

    $('.displayModeBtn').click(function () {
      if ($(this).parents().eq(3).hasClass('mobile_view')) {
        $(this).parents().eq(3).removeClass('mobile_view');
      } else {
        $(this).parents().eq(3).addClass('mobile_view');
      }
    });

    // add listener to control btn group
    socket.once('cut_call', async (data) => {
      if (data.call_id != '') {
        let result = await fetch(
          `${config.__API__}/get/call-log-status?call_id=${data.call_id}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/drupal.single+json; charset=utf-8',
              Accept: 'application/json',
            },
          }
        );
        let response = await result.json();

        if (response.success == true && response.status == 0) {
          let { userData } = await this.props.selectState;
          let currentDate = new Date();
          let callPickTime = localStorage.getItem('call_pick_time');

          callPickTime = new Date(callPickTime);
          localStorage.removeItem('call_pick_time');

          let diff = (currentDate.getTime() - callPickTime.getTime()) / 1000;

          let ExtractSeconds = Math.floor(
            (currentDate.getTime() - callPickTime.getTime()) / 1000
          );
          let totalSeconds = Math.floor(
            (currentDate.getTime() - callPickTime.getTime()) / 1000
          );
          let ExtractMinutes = Math.floor(ExtractSeconds / 60);
          let ExtractHours = Math.floor(ExtractMinutes / 60);
          let ExtractDays = Math.floor(ExtractHours / 24);

          ExtractHours = ExtractHours - ExtractDays * 24;
          ExtractMinutes =
            ExtractMinutes - ExtractDays * 24 * 60 - ExtractHours * 60;
          ExtractSeconds =
            ExtractSeconds -
            ExtractDays * 24 * 60 * 60 -
            ExtractHours * 60 * 60 -
            ExtractMinutes * 60;

          diff =
            ExtractHours +
            ' Hours : ' +
            ExtractMinutes +
            ' Minutes : ' +
            ExtractSeconds +
            ' Seconds';

          let {
            currentSession: { id },
            callStatus,
          } = await this.props.AgoraState;

          if (callStatus === 'initiator') {
            console.log(data);
            await this.props.saveCallHistory(
              diff,
              id,
              userData.id,
              data.hang_by,
              data.hang_by,
              'disconnected',
              totalSeconds
            );
          } else {
            console.log(data);
            await this.props.saveCallHistory(
              diff,
              id,
              data.hang_by,
              userData.id,
              data.hang_by,
              'disconnected',
              totalSeconds
            );
          }
          if (auth.getUserType() === 'User') {
            this.props.history.push('/dashboard/appointments');
          } else {
            this.props.history.push('/coach/dashboard');
          }
        }
      }
    });

    let canvas = document.querySelector('#ag-canvas');
    let btnGroup = document.querySelector('.ag-btn-group');
    canvas.addEventListener('mousemove', () => {
      if (global._toolbarToggle) {
        clearTimeout(global._toolbarToggle);
      }

      btnGroup.classList.add('active');
      global._toolbarToggle = setTimeout(function () {
        btnGroup.classList.remove('active');
      }, 2000);
    });
  }

  componentDidUpdate() {
    // rerendering
    let canvas = document.querySelector('#ag-canvas');
    // pip mode (can only use when less than 4 people in channel)
    if (this.state.displayMode === 'pip') {
      let no = this.state.streamList.length;
      this.state.streamList.map((item, index) => {
        let id = item.getId();
        let dom = document.querySelector('#ag-item-' + id);
        if (!dom) {
          dom = document.createElement('section');
          dom.setAttribute('id', 'ag-item-' + id);
          dom.setAttribute('class', 'ag-item');
          canvas.appendChild(dom);
          item.play('ag-item-' + id);
        }

        if (auth.getUserType() === 'User') {
          if (index === no - 1) {
            dom.setAttribute(
              'style',
              `grid-area: span 3/span 4/${4 + 3 * index}/25;
              z-index:1;width:calc(120px);height:calc(100% - 20px);position: absolute;
              height: 10em;
              right: 2%;
              top: 2%;`
            );
          } else {
            dom.setAttribute('style', `grid-area: span 12/span 24/13/25`);
          }
        } else if (auth.getUserType() === 'counsellor') {
          if (index === no - 1) {
            dom.setAttribute(
              'style',
              `grid-area: span 3/span 4/${4 + 3 * index}/25;
                      z-index:1;width:calc(120px);height:calc(100% - 20px);position: absolute;
                      height: 10em;
                      right: 2%;
                      top: 2%;`
            );
          } else {
            dom.setAttribute('style', `grid-area: span 12/span 24/13/25`);
          }
        }
        item.player.resize && item.player.resize();
      });
    }
    // tile mode
    else if (this.state.displayMode === 'tile') {
      let no = this.state.streamList.length;
      this.state.streamList.map((item, index) => {
        let id = item.getId();
        let dom = document.querySelector('#ag-item-' + id);
        if (!dom) {
          dom = document.createElement('section');
          dom.setAttribute('id', 'ag-item-' + id);
          dom.setAttribute('class', 'ag-item');
          canvas.appendChild(dom);
          item.play('ag-item-' + id);
        }
        dom.setAttribute('style', `grid-area: ${tile_canvas[no][index]}`);
        item.player.resize && item.player.resize();
      });
    }
  }

  componentWillUnmount() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE11 */
      document.msExitFullscreen();
    }

    let { sessionData } = this.props.selectState;
    localStorage.setItem(
      'join_status',
      JSON.stringify({ id: sessionData.booking_id })
    );

    const video = document.querySelector('video');
    if (video !== null) {
      const mediaStream = video.srcObject;
      const tracks = mediaStream.getTracks();
      tracks[0].stop();
      tracks.forEach((track) => track.stop());
    }

    this.client && this.client.unpublish(this.localStream);
    this.localStream &&
      this.client &&
      this.client.leave(
        () => {
          console.log('Client succeed to leave.');
        },
        () => {
          console.log('Client failed to leave.');
        }
      );
  }

  streamInit = (uid, attendeeMode, videoProfile, config) => {
    let defaultConfig = {
      streamID: uid,
      audio: true,
      video: true,
      screen: false,
    };

    switch (attendeeMode) {
      case 'audio-only':
        defaultConfig.video = false;
        break;
      case 'audience':
        defaultConfig.video = false;
        defaultConfig.audio = false;
        break;
      default:
      case 'video':
        break;
    }

    let stream = AgoraRTC.createStream(merge(defaultConfig, config));
    stream.setVideoProfile(videoProfile);
    return stream;
  };

  subscribeStreamEvents = () => {
    let rt = this;
    let props = this.props;
    rt.client.on('stream-added', function (evt) {
      let stream = evt.stream;
      console.log('New stream added: ' + stream.getId());
      console.log('At ' + new Date().toLocaleTimeString());
      console.log('Subscribe ', stream);
      rt.client.subscribe(stream, function (err) {
        console.log('Subscribe stream failed', err);
      });

      props.setAlertMessage({ message: 'Call connected !!', color: 'green' });
      setTimeout(() => {
        props.setAlertMessage({ message: '', color: '' });
      }, 5000);
    });

    rt.client.on('peer-leave', function (evt) {
      rt.removeStream(evt.uid);
      props.setAlertMessage({
        message: 'Call has been disconnected!',
        color: 'teal',
      });
      if (auth.getUserType() === 'User') {
        props.history.push('/dashboard/appointments');
      } else {
        props.history.push('/coach/dashboard');
      }

      setTimeout(() => {
        props.setAlertMessage({ message: '', color: '' });
      }, 5000);
    });

    rt.client.on('stream-subscribed', function (evt) {
      let stream = evt.stream;
      console.log('Got stream-subscribed event');
      console.log(new Date().toLocaleTimeString());
      console.log('Subscribe remote stream successfully: ' + stream.getId());
      console.log(evt);
      rt.addStream(stream);
    });

    rt.client.on('stream-removed', function (evt) {
      let stream = evt.stream;
      console.log('Stream removed: ' + stream.getId());
      console.log(new Date().toLocaleTimeString());
      console.log(evt);
      rt.removeStream(stream.getId());
    });
  };

  removeStream = (uid) => {
    this.state.streamList.map((item, index) => {
      if (item.getId() === uid) {
        item.close();
        let element = document.querySelector('#ag-item-' + uid);
        if (element) {
          element.parentNode.removeChild(element);
        }
        let tempList = [...this.state.streamList];
        tempList.splice(index, 1);
        this.setState({
          streamList: tempList,
        });
      }
    });
  };

  addStream = (stream, push = false) => {
    let repeatition = this.state.streamList.some((item) => {
      return item.getId() === stream.getId();
    });

    if (repeatition) {
      return;
    }

    if (push) {
      this.setState({
        streamList: this.state.streamList.concat([stream]),
      });
    } else {
      this.setState({
        streamList: [stream].concat(this.state.streamList),
      });
    }
  };

  handleCamera = (e) => {
    e.currentTarget.classList.toggle('off');
    this.localStream.isVideoOn()
      ? this.localStream.disableVideo()
      : this.localStream.enableVideo();
  };

  handleMic = (e) => {
    e.currentTarget.classList.toggle('off');
    this.localStream.isAudioOn()
      ? this.localStream.disableAudio()
      : this.localStream.enableAudio();
  };

  switchDisplay = (e) => {
    if (
      e.currentTarget.classList.contains('disabled') ||
      this.state.streamList.length <= 1
    ) {
      return;
    }
    if (this.state.displayMode === 'pip') {
      this.setState({ displayMode: 'tile' });
    } else if (this.state.displayMode === 'tile') {
      this.setState({ displayMode: 'pip' });
    } else if (this.state.displayMode === 'share') {
    } else {
      console.error('Display Mode can only be tile/pip/share');
    }
  };

  handleExit = (e) => {
    let {
      sender,
      userData: { id },
    } = this.props.selectState;
    // socket.emit('disconnect_call', {
    //   sender,
    //   ...{ success: true, hang_by: id },
    // });
    const channel_id = localStorage.getItem('channelName');
    const userType = localStorage.getItem('USER_TYPE');
    firebase
      .database()
      .ref('caocherlyAppointCall')
      .child(channel_id)
      .update({ callStatus: 2, rejectBy: userType });
    firebase.database().ref('caocherlyAppointCall').child(channel_id).remove();
    if (e.currentTarget.classList.contains('disabled')) {
      return;
    }
    localStorage.removeItem('channelName');
    try {
      this.client && this.client.unpublish(this.localStream);
      // this.localStream && this.localStream.close();
      this.client &&
        this.client.leave(
          () => {
            console.log('Client succeed to leave.');
          },
          () => {
            console.log('Client failed to leave.');
          }
        );
    } finally {
      this.setState({ readyState: false });
      this.client = null;
      this.localStream = null;
      // window.location.hash = "";
    }

    if (auth.getUserType() === 'User') {
      this.props.history.push('/dashboard/appointments');
      localStorage.setItem('call_status', 'ended');
      localStorage.removeItem('channelName');
    } else {
      this.props.history.push('/coach/dashboard');
      localStorage.removeItem('channelName');
    }
  };

  render() {
    const style = {
      display: 'grid',
      gridGap: '10px',
      alignItems: 'center',
      justifyItems: 'center',
      gridTemplateRows: 'repeat(12, auto)',
      gridTemplateColumns: 'repeat(24, auto)',
    };

    const videoControlBtn =
      this.attendeeMode === 'video' ? (
        <Link
          to="#"
          onClick={this.handleCamera}
          className="ag-btn videoControlBtn"
          title="Enable/Disable Video"
        >
          <i className="ag-icon ag-icon-camera"></i>
          <i className="ag-icon ag-icon-camera-off"></i>
        </Link>
      ) : (
        ''
      );

    const audioControlBtn =
      this.attendeeMode !== 'audience' ? (
        <span
          onClick={this.handleMic}
          className="ag-btn audioControlBtn"
          title="Enable/Disable Audio"
        >
          <i className="ag-icon ag-icon-mic"></i>
          <i className="ag-icon ag-icon-mic-off"></i>
        </span>
      ) : (
        ''
      );

    const switchDisplayBtn = (
      <span
        onClick={this.switchDisplay}
        className={
          this.state.streamList.length > 4
            ? 'ag-btn displayModeBtn disabled'
            : 'ag-btn displayModeBtn'
        }
        title="Switch Display Mode"
      >
        <i className="ag-icon ag-icon-switch-display"></i>
      </span>
    );

    const exitBtn = (
      <Link
        to="#"
        onClick={this.handleExit}
        className="ag-btn exitBtn"
        title="Exit"
      >
        <i className="ag-icon ag-icon-leave"></i>
      </Link>
    );
    let { showTimer } = this.state;

    const Timer = (
      <Countdown
        date={Date.now() + 5 * 60000}
        onStop={(e) => this.calcTimeDelta(e)}
        renderer={(props) => (
          <div>
            {props.minutes}
            {':'}
            {props.seconds}
          </div>
        )}
      />
    );

    // let { currentSession } = this.props.AgoraState;
    // let st = moment(currentSession.slot, "HH:mm A").toDate();
    // let endTime = moment(st).add(currentSession.time, "m").toDate();
    // endTime.setMinutes(endTime.getMinutes() - 5);
    // let interval = Math.abs(new Date().getTime() - endTime.getTime()) / 1000 / 60;
    // console.log(interval);

    return (
      <Fragment>
        <div className="wrapper meeting">
          <div className="ag-main">
            <div id="ag-canvas" style={style}>
              <div className="ag-btn-group">
                {showTimer ? Timer : null}
                {/* {interval && (
                  <Delayed waitBeforeShow={interval}>{Timer}</Delayed>
                )} */}
                {audioControlBtn}
                {videoControlBtn}
                {exitBtn}
                {switchDisplayBtn}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Meeting;



// WEBPACK FOOTER //
// ./src/routes/VideoSession/Components/Meeting.js